import { graphql } from '@guuru/graphql-common/gql';

export default graphql(`
  query GetPersistedCommunityFeedbacks($partnerId: ID!) {
    community(id: $partnerId) {
      id
      bestFeedbackComments {
        comment
        expert {
          id
          externalId
          name
        }
      }
    }
  }
`);
